import React from 'react'
import { parseHostname } from '@/lib/parseHostname'
import { Logo } from '@/materials'
import { createGlobalStyle } from 'styled-components'

const currentYear = new Date().getFullYear()

class Footer extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    // console.log('### componentDidMount')
  }

  componentDidUpdate() {}

  render() {
    const homeURL = `https://www.${parseHostname().publicationDomain}`

    return (
      <div className="ta-footer">
        <Style />

        <div className="footertop">
          <div className="tenant-logo">
            <a href={homeURL} target="_top">
              <Logo />
            </a>
          </div>
          <div className="credits">{this.props.credits[0][0] + ': ' + this.props.credits[0][1]}</div>
        </div>
        <div className="footerbottom">© {currentYear} Tamedia. All Rights Reserved</div>
      </div>
    )
  }
}

export default Footer

const Style = createGlobalStyle`
  .ta-footer {
    font-family: var(--font-sans-serif);
    color: var(--color-gray-gray-2);
    @media (prefers-color-scheme: dark) {
      color: var(--color-gray-gray-4);
    }
    font-size: 0.95rem;
    text-align: center;
    border-top: 0.1rem solid var(--color-gray-gray-4);
    .footertop {
      padding: 4rem 4rem 2.5rem;
      background-color: var(--color-beige-bright-3);
      @media (prefers-color-scheme: dark) {
        background-color: #474A66;
      }
      .tenant-logo {
        img {
          margin: 0 auto;
        }
      }
      .credits {
        padding: 2rem 0 0;
      }
    }
    .footerbottom {
      padding: 1.9rem 0 2rem;
      font-size: 0.9rem;
      color: #fff;
      letter-spacing: 0.5px;
      background-color: var(--color-brandblue-main);
    }
  }
`
